module.exports = __webpack_public_path__ + "static/media/Home-background-2x.9467aa0f.jpg";